export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}room/room/:id`;

    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Room/index.js